(function () {
	'use strict';

	angular.module('dcApp').factory('UserGroupService', [
		'$http',
		'$rootScope',
		'API_BASE_URL_BACKEND',
		'$q',
		'GroupAdapter',
		function ($http, $rootScope, API_BASE_URL_BACKEND, $q, GroupAdapter) {
			var UserGroupService = {};

			UserGroupService.getGroups = function () {
				const deferred = $q.defer();
				const url = API_BASE_URL_BACKEND + $rootScope.getUrl('GROUPS_GET_ALL');
				$http.get(url).then(function (response) {
					deferred.resolve(GroupAdapter.generateGroupList(response.data));
				});
				return deferred.promise;
			};

			UserGroupService.getCurrentUserGroups = function () {
				var url = API_BASE_URL_BACKEND + $rootScope.getUrl('USER_GROUP');
				return $http.get(url).then(function (response) {
					return response;
				});
			};

			UserGroupService.getGroupsByUser = function (userId) {
				const deferred = $q.defer();
				var url = API_BASE_URL_BACKEND + $rootScope.getUrl('GROUPS_BY_USER');
				url = url.replace('{userId}', userId);
				$http.get(url).then(function (response) {
					deferred.resolve(response);
				});
				return deferred.promise;
			};

			UserGroupService.getGroup = function (groupId) {
				const deferred = $q.defer();
				var url = API_BASE_URL_BACKEND + $rootScope.getUrl('GROUPS_GET');
				url = url.replace('{id}', groupId);
				$http.get(url).then(function (response) {
					deferred.resolve(GroupAdapter.generateGroup(response.data));
				});
				return deferred.promise;
			};

			UserGroupService.getMembers = function (groupId) {
				var url =
					API_BASE_URL_BACKEND + $rootScope.getUrl('GROUPS_MEMBERS_GET');
				url = url.replace('{id}', groupId);
				return $http.get(url).then(function (response) {
					return response;
				});
			};

			UserGroupService.getAvailableUsers = function (groupId) {
				var url =
					API_BASE_URL_BACKEND + $rootScope.getUrl('GROUPS_AVAILABLE_USERS');
				if (groupId !== null && groupId !== undefined) {
					url = url + '?groupId=' + groupId;
				}
				return $http.get(url).then(function (response) {
					return response;
				});
			};

			return UserGroupService;
		},
	]);
})();
